import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ConfigProvider } from "@/lib/useConfig";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Landing from "@/pages/Landing";
import ToolPage from "@/pages/ToolPage";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Contact from "@/pages/Contact";
import Success from "@/pages/Success";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <ConfigProvider>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/ferramenta" element={<ToolPage />} />
            <Route path="/termos" element={<Terms />} />
            <Route path="/privacidade" element={<Privacy />} />
            <Route path="/contato" element={<Contact />} />
            <Route path="/sucesso" element={<Success />} />
          </Routes>
          <Footer />
          <Toaster position="top-center" theme="dark" richColors />
        </ConfigProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
